import { render, staticRenderFns } from "./Header copy.vue?vue&type=template&id=e2946572&scoped=true"
import script from "./Header copy.vue?vue&type=script&lang=js"
export * from "./Header copy.vue?vue&type=script&lang=js"
import style0 from "./Header copy.vue?vue&type=style&index=0&id=e2946572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2946572",
  null
  
)

export default component.exports